import React, { useContext } from "react";
import "./App.css";
import { Toaster } from "sonner";
import { AuthProvider, AuthContext } from "./AuthContext";
import AuthPage from "./components/AuthPage";
import Dashboard from "./components/Dashboard";
import SessionWarning from "./components/SessionWarning";

const AppContent = () => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {user ? <Dashboard /> : <AuthPage />}
      {user && <SessionWarning />}
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <Toaster position="bottom-right" richColors />
      <AppContent />
    </AuthProvider>
  );
}

export default App;
